import script from "./Mbank-Settings-Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Mbank-Settings-Users.vue?vue&type=script&setup=true&lang=js"

import "./Mbank-Settings-Users.vue?vue&type=style&index=0&id=49e02f04&lang=css"

const __exports__ = script;

export default __exports__